import { RESET_SELECT_JOURNAL, SELECT_JOURNAL_BY_MATCH, SET_MATCHES_BY_TOURNAMENTS } from "../constants/matches"

export const setMatchesByTournament = matches => dispatch =>{
    dispatch({
        type: SET_MATCHES_BY_TOURNAMENTS,
        payload: matches
    })
}

export const selectJournal = (journal)=> dispatch =>{
    dispatch({
        type: SELECT_JOURNAL_BY_MATCH,
        payload: journal
    })

}

export const resetJournal = ()=> dispatch =>{
    dispatch({
        type: RESET_SELECT_JOURNAL
    })
}